module.exports = __webpack_public_path__ + "static/media/pic-ht13.3ddeffab.jpg";